import { setupAlgoliaListeners } from '@state/slices/algolia/algoliaListeners';
import { setupFiltersListeners } from '@state/slices/filters/filterListeners';
import { setupLoggingListeners } from '@state/slices/logging/loggingSlice';
import { setupModalListeners } from '@state/slices/modal/modalListeners';
import { setupPriceCalendarListeners } from '@state/slices/price-calendar/priceCalendarListeners';
import { setupSeatMapsListeners } from '@state/slices/seat-maps';
import { setupCommonSearchListeners } from '@state/slices/search/common/commonSearchListener';
import { setupDealFinderResultsStateListeners } from '@state/slices/deal-finder-results/dealFinderResultsStateListeners';
import { setListenersInitialized } from './createListener';

export const initializeListeners = () => {
  // Import and setup all listeners
  setupAlgoliaListeners();
  setupFiltersListeners();
  setupLoggingListeners();
  setupModalListeners();
  setupPriceCalendarListeners();
  setupSeatMapsListeners();
  setupCommonSearchListeners();
  setupDealFinderResultsStateListeners();

  // Mark listeners as initialized
  setListenersInitialized(true);
};
